/* unplugin-vue-components disabled */import _toConsumableArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/filter.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0c71ceaa"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "device-info-page"
};
var _hoisted_2 = {
  class: "device-info-top"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, null, -1);
});
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "filter-top-title"
  }, "更多筛选", -1);
});
var _hoisted_5 = {
  class: "filter-content"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "filter-content-label"
  }, "设备类型", -1);
});
var _hoisted_7 = {
  class: "filter-content"
};
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "filter-content-label"
  }, "设备状态", -1);
});
var _hoisted_9 = {
  class: "popup-btn filter-action-btn"
};
import { showToast } from 'vant';
import { useStore } from '@/store';
import CollapseList from './CollapseList.vue';
import { getDeviceInfoList, getDeviceType } from '@/service/deviceInfo/index';
import './index.less';
import './common.less';
var __default__ = {
  name: 'DeviceInfo'
};
export default /*#__PURE__*/_defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  setup: function setup(__props) {
    var store = useStore();
    var searchVal = ref('');
    var filterModalShow = ref(false);
    // 设备类型
    var deviceType = reactive({
      value: '',
      label: ''
    });
    var deviceColumns = ref([]);
    //设备状态deviceStatus
    var deviceStatus = reactive({
      value: '',
      text: ''
    });
    var showStatusPicker = ref(false);
    var statusColumns = ref([{
      text: '启用',
      status: 0
    }, {
      text: '停用',
      status: 1
    }, {
      text: '报废',
      status: 2
    }]);
    var oldScrollTop = ref(0);
    var loading = ref(true);
    var listloading = ref(false);
    var page = ref(1);
    var pageSize = ref(15);
    var totalPage = ref(0);
    var showDevicePicker = ref(false);
    var finished = ref(false);
    var deviceList = ref([]);
    var scrollTop = computed(function () {
      return store.getters['deviceInfo/getScrollTop'];
    });
    var onRefresh = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              finished.value = false;
              _context.prev = 1;
              page.value = 1;
              _context.next = 5;
              return getList({
                deviceTypeCode: deviceType.value,
                status: deviceStatus.value,
                deviceName: searchVal.value
              });
            case 5:
              showToast('刷新成功');
              loading.value = false;
              _context.next = 13;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              showToast('刷新失败');
              loading.value = false;
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 9]]);
      }));
      return function onRefresh() {
        return _ref.apply(this, arguments);
      };
    }();
    var onSearchVal = function onSearchVal(value) {
      finished.value = false;
      page.value = 1;
      getList({
        deviceName: value,
        deviceTypeCode: deviceType.value,
        status: deviceStatus.value
      });
    };
    var onClear = function onClear(value) {
      finished.value = false;
      page.value = 1;
      getList({
        deviceName: value,
        deviceTypeCode: deviceType.value,
        status: deviceStatus.value
      });
    };
    var onLoad = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              listloading.value = true;
              _context2.next = 4;
              return getList({
                deviceTypeCode: deviceType.value,
                status: deviceStatus.value,
                deviceName: searchVal.value
              });
            case 4:
              listloading.value = false;
              _context2.next = 11;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              listloading.value = false;
              finished.value = true;
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 7]]);
      }));
      return function onLoad() {
        return _ref2.apply(this, arguments);
      };
    }();
    var onFilterSearch = function onFilterSearch() {
      filterModalShow.value = true;
    };
    var onDeviceConfirm = function onDeviceConfirm(value) {
      showDevicePicker.value = false;
      deviceType.value = value === null || value === void 0 ? void 0 : value.dictValue;
      deviceType.label = value === null || value === void 0 ? void 0 : value.dictLabel;
    };
    var onRest = function onRest() {
      deviceStatus.text = '';
      deviceStatus.value = '';
      deviceType.label = '';
      deviceType.value = '';
    };
    var onFilterOk = function onFilterOk() {
      filterModalShow.value = false;
      finished.value = false;
      page.value = 1;
      getList({
        deviceTypeCode: deviceType.value,
        status: deviceStatus.value,
        deviceName: searchVal.value
      });
    };
    var onFilterCancel = function onFilterCancel() {
      filterModalShow.value = false;
    };
    var onStatusConfirm = function onStatusConfirm(value) {
      deviceStatus.value = value === null || value === void 0 ? void 0 : value.status;
      deviceStatus.text = value === null || value === void 0 ? void 0 : value.text;
      showStatusPicker.value = false;
    };
    var onScrollHandle = function onScrollHandle(event) {
      // 滚动条距文档顶部的距离
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // 更新——滚动前，滚动条距文档顶部的距离
      oldScrollTop.value = scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      //滚动条到底部的条件
      // if (scrollTop + windowHeight == scrollHeight) {
      //   isRequir.value = true;
      // }
      store.commit('deviceInfo/setScrollTop', scrollTop);
    };
    var getList = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(params) {
        var _newList, data, records, pages, newList, newRecords;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              listloading.value = true;
              _context3.prev = 1;
              _context3.next = 4;
              return getDeviceInfoList({
                pageIndex: page.value,
                pageSize: pageSize.value,
                t: params
              });
            case 4:
              data = _context3.sent;
              records = data.records, pages = data.pages;
              totalPage.value = pages;
              newList = _toConsumableArray(deviceList.value);
              newRecords = records.map(function (el) {
                var newEl = _objectSpread(_objectSpread({}, el), {}, {
                  dictLabel: ''
                });
                deviceColumns.value.forEach(function (item) {
                  if (el.deviceTypeCode === item.dictValue) {
                    newEl.dictLabel = item.dictLabel;
                  }
                });
                return newEl;
              });
              if (page.value === 1) {
                newList = [];
              }
              (_newList = newList).push.apply(_newList, _toConsumableArray(newRecords));
              if (page.value >= pages) {
                finished.value = true;
              }
              page.value = page.value + 1;
              deviceList.value = newList;
              listloading.value = false;
              return _context3.abrupt("return", Promise.resolve());
            case 18:
              _context3.prev = 18;
              _context3.t0 = _context3["catch"](1);
              listloading.value = false;
              finished.value = true;
              return _context3.abrupt("return", Promise.reject());
            case 23:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 18]]);
      }));
      return function getList(_x) {
        return _ref3.apply(this, arguments);
      };
    }();
    // 获取设备类型
    var getDeviceTypeList = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var data, list;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return getDeviceType('device_type');
            case 2:
              data = _context4.sent;
              list = data.list;
              deviceColumns.value = list;
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function getDeviceTypeList() {
        return _ref4.apply(this, arguments);
      };
    }();
    onActivated(function () {
      document.documentElement.scrollTop = scrollTop.value;
    });
    onMounted(function () {
      // 监听页面滚动事件
      document.documentElement.scrollTop = 0;
      window.addEventListener('scroll', onScrollHandle, {
        passive: true
      });
      getDeviceTypeList();
      getList();
    });
    onUnmounted(function () {
      window.removeEventListener('scroll', onScrollHandle);
    });
    return function (_ctx, _cache) {
      var _component_van_search = _resolveComponent("van-search");
      var _component_van_list = _resolveComponent("van-list");
      var _component_van_field = _resolveComponent("van-field");
      var _component_van_picker = _resolveComponent("van-picker");
      var _component_van_popup = _resolveComponent("van-popup");
      var _component_van_button = _resolveComponent("van-button");
      var _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_search, {
        modelValue: _unref(searchVal),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(searchVal) ? searchVal.value = $event : null;
        }),
        "show-action": "",
        placeholder: "搜索设备名称",
        onSearch: onSearchVal,
        onClear: onClear
      }, {
        action: _withCtx(function () {
          return [_createElementVNode("div", {
            class: "right-filter"
          }, [_createElementVNode("div", {
            onClick: onFilterSearch,
            class: "filter-text"
          }, "筛选"), _createElementVNode("img", {
            onClick: onFilterSearch,
            src: _imports_0
          })])];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createVNode(_component_van_pull_refresh, {
        modelValue: _unref(loading),
        "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) {
          return _isRef(loading) ? loading.value = $event : null;
        }),
        onRefresh: onRefresh
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_list, {
            loading: _unref(listloading),
            "onUpdate:loading": _cache[1] || (_cache[1] = function ($event) {
              return _isRef(listloading) ? listloading.value = $event : null;
            }),
            finished: _unref(finished),
            "finished-text": "没有更多了",
            onLoad: onLoad,
            "immediate-check": false
          }, {
            default: _withCtx(function () {
              return [_createVNode(CollapseList, {
                listData: _unref(deviceList)
              }, null, 8, ["listData"])];
            }),
            _: 1
          }, 8, ["loading", "finished"]), _createVNode(_component_van_popup, {
            show: _unref(filterModalShow),
            "onUpdate:show": _cache[10] || (_cache[10] = function ($event) {
              return _isRef(filterModalShow) ? filterModalShow.value = $event : null;
            }),
            position: "bottom",
            class: "filter-modal-show"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", {
                class: "filter-top"
              }, [_hoisted_3, _hoisted_4, _createElementVNode("div", {
                class: "filter-top-cancel",
                onClick: onFilterCancel
              }, "取消")]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_van_field, {
                modelValue: _unref(deviceType).label,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                  return _unref(deviceType).label = $event;
                }),
                "is-link": "",
                readonly: "",
                placeholder: "请选择",
                onClick: _cache[3] || (_cache[3] = function ($event) {
                  return showDevicePicker.value = true;
                })
              }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
                show: _unref(showDevicePicker),
                "onUpdate:show": _cache[5] || (_cache[5] = function ($event) {
                  return _isRef(showDevicePicker) ? showDevicePicker.value = $event : null;
                }),
                round: "",
                position: "bottom"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_van_picker, {
                    columns: _unref(deviceColumns),
                    "columns-field-names": {
                      text: 'dictLabel',
                      values: 'dictValue'
                    },
                    onCancel: _cache[4] || (_cache[4] = function ($event) {
                      return showDevicePicker.value = false;
                    }),
                    onConfirm: onDeviceConfirm
                  }, null, 8, ["columns"])];
                }),
                _: 1
              }, 8, ["show"])]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_van_field, {
                modelValue: _unref(deviceStatus).text,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
                  return _unref(deviceStatus).text = $event;
                }),
                "is-link": "",
                readonly: "",
                placeholder: "请选择",
                onClick: _cache[7] || (_cache[7] = function ($event) {
                  return showStatusPicker.value = true;
                })
              }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
                show: _unref(showStatusPicker),
                "onUpdate:show": _cache[9] || (_cache[9] = function ($event) {
                  return _isRef(showStatusPicker) ? showStatusPicker.value = $event : null;
                }),
                round: "",
                position: "bottom"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_van_picker, {
                    columns: _unref(statusColumns),
                    "columns-field-names": {
                      values: 'status'
                    },
                    onCancel: _cache[8] || (_cache[8] = function ($event) {
                      return showStatusPicker.value = false;
                    }),
                    onConfirm: onStatusConfirm
                  }, null, 8, ["columns"])];
                }),
                _: 1
              }, 8, ["show"])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_van_button, {
                type: "default",
                onClick: onRest
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode("重置")];
                }),
                _: 1
              }), _createVNode(_component_van_button, {
                type: "primary",
                onClick: onFilterOk
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode("确定筛选")];
                }),
                _: 1
              })])];
            }),
            _: 1
          }, 8, ["show"])];
        }),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
}));